import { canonicalJson, Role, } from "@gigsync/protocol";
import { bothSigned } from "../payments/passbook.js";
import { outcomeOf, paymentOf, submissionOf } from "./facts.js";
import { restoredOutcome } from "./follow.js";
/** What kind of fact a report carries, in the order the server needs them: the job first, then what follows it. */
export const ReportKind = { job: "job", status: "status", payment: "payment", stars: "stars" };
const ID_SEP = ":";
const reportId = (...parts) => parts.join(ID_SEP);
/** The content of a report as compared with what the server accepted: the same facts give the same text. */
export const fingerprint = (report) => canonicalJson(report.body);
/**
 * Every fact this phone owes the server about its jobs, as it holds them now (ADR 0038 §2): for each job both signed,
 * its submission (either side), how it ended (either side), the payments the worker confirmed (worker's side) and the
 * household's stars (household's side); for a restored job, how it ended. Pure: what was already accepted is left out
 * by the caller.
 */
export function recordsDue(jobs, payments) {
    const due = [];
    for (const job of jobs) {
        const engagement = job.engagement.id;
        // A restored job is on the record already; all it can owe is how it ended, from its own card (follow.ts).
        const ending = restoredOutcome(job);
        if (ending)
            due.push({ id: reportId(ReportKind.status, engagement), engagement, kind: ReportKind.status, body: ending });
        if (!bothSigned(job))
            continue;
        const submit = submissionOf(job);
        if (!submit)
            continue;
        due.push({ id: reportId(ReportKind.job, engagement), engagement, kind: ReportKind.job, body: submit });
        const outcome = outcomeOf(job);
        if (outcome)
            due.push({ id: reportId(ReportKind.status, engagement), engagement, kind: ReportKind.status, body: outcome });
        for (const p of payments) {
            const body = p.engagement === engagement ? paymentOf(job, p) : undefined;
            if (body)
                due.push({ id: reportId(ReportKind.payment, p.id), engagement, kind: ReportKind.payment, body });
        }
        if (job.review && job.engagement.role === Role.enum.requester)
            due.push({
                id: reportId(ReportKind.stars, engagement),
                engagement,
                kind: ReportKind.stars,
                body: { stars: job.review.stars },
            });
    }
    return due;
}
//# sourceMappingURL=due.js.map